(() => {
  const section = document.querySelector('.nextdev--scroll-down-button');
  const scrollDownPrimary = section.querySelector('.nextdev--scroll-down-button--primary');
  const ctaButton = section.querySelector('.nextdev--scroll-down-button--cta');
  let ctaButtonSection = null;
  if (ctaButton != null) {
    const ctaButtonSectionID = ctaButton.getAttribute('data-section');

    if (ctaButtonSectionID != undefined) {
      ctaButtonSection = document.querySelector(ctaButtonSectionID);
    }
  }

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset ||
                      document.documentElement.scrollTop ||
                      document.body.scrollTop;

    if (scrollTop >= 100) {
      if (!scrollDownPrimary.classList.contains('hide')) {
        scrollDownPrimary.classList.add('hide');
      }

      if (ctaButtonSection != null) {
        const rect = ctaButtonSection.getBoundingClientRect();
        const midY = window.innerHeight / 2;

        if (rect.top <= midY) {
          ctaButton.classList.add('reached');
        }
      }
    } else if (scrollTop < 100 && scrollDownPrimary.classList.contains('hide')) {
      if (ctaButton == null || !ctaButton.classList.contains('reached')) {
        scrollDownPrimary.classList.remove('hide');
      }
    }
  });

  scrollDownPrimary.addEventListener('click', () => {
    const scrollToSection = scrollDownPrimary.getAttribute('data-scrollto');

    if (scrollToSection != undefined) {
      const sectionElement = document.querySelector(scrollToSection);

      if (sectionElement != null) {
        sectionElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      }
    }
  });

})();
